import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { defineCustomElements } from '@cmx-web-components/core/loader';

if (environment.production) {
  enableProdMode();
}

// TODO: Remove this after we get rid of the old code!!!
window['API_HOST'] = environment.apiHost || console.error('API HOST not set');
window['APP_CODE'] = environment.appCode || '';
window['COUNTLY_KEY'] = environment.countlyKey || '';
window['COUNTLY_URL'] = environment.countlyUrl || '';
window['TRANSLATE_URL'] = environment.translations.apiHost || '';
window['SHIFT_BUSINESS_LINES'] = environment.features.shiftBusinessLines || false;

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(ref => {
    // Ensure Angular destroys itself on hot reloads.
    if (window['ngRef']) {
      window['ngRef'].destroy();
    }
    window['ngRef'] = ref;

    // Otherise, log the boot error
  })
  .catch(err => console.log(err));

defineCustomElements(window);
